import React, { useState } from "react";
import "./FloatingWhatsappButton.css";
import WhatsApp from "../../Assets/Images/Icons/whatsapp.png"

const FloatingWhatsappButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button className="floating-whatsapp-btn" onClick={() => setIsOpen(!isOpen)}>
        <a
              href="https://api.whatsapp.com/send?phone=+918828103808&text=Hello! I came across your website and would like to know more about your services. Please let me know how we can proceed. Thank you."
              target="_blank"
            >
          <img src={WhatsApp} alt="Contact Dwebbox on WhatsApp" />
        </a>
      </button>
    </>
  );
};

export default FloatingWhatsappButton;
